import { getUserInitials } from '../../utils/userInitials'
import { AvatarContainer, ProfileAvatar, UserName } from './styles/ProfileHeaderStyles'

interface ProfileHeaderProps {
  fullName?: string
  size?: number
}

export function ProfileHeader({ fullName, size = 96 }: ProfileHeaderProps) {
  const initials = getUserInitials(fullName)

  return (
    <AvatarContainer>
      <ProfileAvatar size={size} $avatarSize={size}>
        {initials}
      </ProfileAvatar>
      {fullName && <UserName>{fullName}</UserName>}
    </AvatarContainer>
  )
}
